import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NotificationSystem from 'react-notification-system';
import dateFormat from 'dateformat';
import Select from 'react-select';

import Footer from '../../../Components/Footer/Footer';
import Auth from '../../Authentication/Auth';
import Api from '../../../Services/Api';
import CustomerOrdersSummary from './CustomerOrdersSummary';
import CustomerOrdersList from './CustomerOrdersList';

// import CustomerOrdersSummary from './CustomerOrdersSummary';
// import CustomerOrdersList from './CustomerOrdersList';

const ONE_DAY = 24 * 60 * 60 * 1000;
const INTERVAL_OPTIONS = [{ value: 'daily', label: 'Daily' }, { value: 'monthly', label: 'Monthly' }, { value: 'yearly', label: 'Yearly' }];

class CustomerOrdersPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      queryDate: new Date().getTime(),
      orders: [],
      summary: {},
      reportInterval: 'daily',
      reportIntervalOptions: INTERVAL_OPTIONS
    };

    this.prevDateButtonClicked = this.prevDateButtonClicked.bind(this);
    this.nextDateButtonClicked = this.nextDateButtonClicked.bind(this);
    this.selectIntervalChange = this.selectIntervalChange.bind(this);
    this.renderReportDate = this.renderReportDate.bind(this);
  }

  componentWillMount() {
    this.fetchData(this);
  }

  fetchData() {
    const myHeaders = new Headers();

    const queryParams = `timestamp=${this.state.queryDate}&interval=${this.state.reportInterval}&tailNumber=${this.props.match.params.tailNumber}`;
    const endPoint = `v1/fbos/${this.props.fboId}/reports/customer?${queryParams}`;

    myHeaders.append('X-Api-Key', Auth.getBearerToken());

    this.request = Api.get(endPoint, {
      headers: myHeaders,
    }).then((response) => {
      console.log(response);
      const { summary, orders } = response.report;

      this.setState({ summary, orders });
    }).catch((err) => {
      console.log(err);
    });
  }


  prevDateButtonClicked() {
    let prevDate = this.state.queryDate - ONE_DAY;
    if (this.state.reportInterval === 'monthly') {
      const date = new Date(this.state.queryDate);
      prevDate = new Date(date.getFullYear(), date.getMonth(), -1).getTime();
    } else if (this.state.reportInterval === 'yearly') {
      const date = new Date(this.state.queryDate);
      prevDate = new Date(date.getFullYear(), -1, 1).getTime();
    }
    this.setState({ queryDate: prevDate }, () => {
      this.fetchData();
    });
  }

  nextDateButtonClicked() {
    let nextDate = this.state.queryDate + ONE_DAY;
    if (this.state.reportInterval === 'monthly') {
      const date = new Date(this.state.queryDate);
      nextDate = new Date(date.getFullYear(), date.getMonth() + 1, 1).getTime();
    } else if (this.state.reportInterval === 'yearly') {
      const date = new Date(this.state.queryDate);
      nextDate = new Date(date.getFullYear() + 1, 1, 1).getTime();
    }
    this.setState({ queryDate: nextDate }, () => {
      this.fetchData();
    });
  }

  selectIntervalChange(inputValue) {
    const value = inputValue === null ? inputValue : inputValue.value;
    this.setState({ reportInterval: value }, () => {
      this.fetchData();
    });
  }

  handlePrint() {
    window.print();
  }

  renderReportDate() {
    if (this.state.reportInterval === 'daily') {
      return (
        <h3>{dateFormat(this.state.queryDate, 'fullDate')}</h3>
      );
    }

    if (this.state.reportInterval === 'monthly') {
      const dateFormatOptions = { year: 'numeric', month: 'long' };
      return (
        <h3>{new Date(this.state.queryDate).toLocaleDateString('en-US', dateFormatOptions)}</h3>
      );
    }

    const dateFormatOptions = { year: 'numeric' };
    return (
      <h3>{new Date(this.state.queryDate).toLocaleDateString('en-US', dateFormatOptions)}</h3>
    );
  }

  render() {
    const { summary } = this.state;
    return (
      <div className="app">
        <NotificationSystem ref={(node) => { this.notificationSystem = node; }} />
        <main className="page-content">
          <div className="reports-logo">
            <img alt="logo" src="https://pictures.dealer.com/t/tomwoodaviation/1142/45644ba64046387201eb9fdee519ecec.jpg" />
          </div>
          <div className="orders-page-header">
            <h1>Customer Orders Report</h1>
            <div className="date-navigation">
              <button className="prev" onClick={this.prevDateButtonClicked}> &#60; </button>
              <button className="next" onClick={this.nextDateButtonClicked}> &#62; </button>
            </div>
            {this.renderReportDate()}
            <Select
              id="reportInterval"
              name="fuel-type-select"
              value={this.state.reportInterval}
              options={this.state.reportIntervalOptions}
              onChange={this.selectIntervalChange}
              clearable={false}
            />
            <button
              className="btn btn-medium btn-primary right btn-print"
              onClick={this.handlePrint}
            >
              Print
            </button>
          </div>
          <section className="order-group">
            <CustomerOrdersSummary summary={this.state.summary} />
          </section>
          <section className="order-group">
            <CustomerOrdersList orders={this.state.orders} />
          </section>
          <Footer />
        </main>
      </div>
    );
  }
}

CustomerOrdersPage.propTypes = {
  fboId: PropTypes.number.isRequired,
};

export default CustomerOrdersPage;




// WEBPACK FOOTER //
// ./src/Containers/Reports/CustomerOrders/CustomerOrdersPage.js